import { render, staticRenderFns } from "./QueryPractice.vue?vue&type=template&id=54c938cc&scoped=true"
import script from "./QueryPractice.vue?vue&type=script&lang=js"
export * from "./QueryPractice.vue?vue&type=script&lang=js"
import style0 from "./QueryPractice.vue?vue&type=style&index=0&id=54c938cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c938cc",
  null
  
)

export default component.exports